module.exports = __webpack_public_path__ + "img/b2143bb70e2bddd02bacf27a0671b564.png";